module["exports"] = [
  "01##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/postcode.js
// module id = 1714
// module chunks = 0